import { useState } from 'react';

import type { FormInstance } from '@arco-design/web-react';

import { clearCpuFields, clearGpuFields, clearMemoryFields } from '../domain/form';
import type { ComputeModalResourceKind, ComputePaths } from '../types';

interface UseComputeBlockStateOptions {
  form: FormInstance;
  paths: ComputePaths;
}

/** 主面板状态：当前打开的弹窗类型、删除资源 */
export function useComputeBlockState({ form, paths }: UseComputeBlockStateOptions) {
  const [activeModal, setActiveModal] = useState<ComputeModalResourceKind | null>(null);

  const openModal = (kind: ComputeModalResourceKind) => setActiveModal(kind);
  const closeModal = () => setActiveModal(null);

  const handleRemoveResource = (kind: ComputeModalResourceKind) => {
    if (kind === 'cpu') {
      clearCpuFields(form, paths);
    } else if (kind === 'memory') {
      clearMemoryFields(form, paths);
    } else {
      clearGpuFields(form, paths);
    }
  };

  return {
    activeModal,
    openModal,
    closeModal,
    handleRemoveResource,
  };
}
